import VideoControlBtn from './VideoControlBtn'
export default VideoControlBtn